import { _ } from "~/i18n";
import { node } from "~/util/dom";

interface IMyMapsCreateFolder {
	onSave?: (folderId: string, folderTitle: string) => void;
	onClose?: () => void;
}

interface IDom {
	container: HTMLDivElement;
	input: HTMLInputElement;
	error: HTMLParagraphElement;
	saveBtn: HTMLButtonElement;
	cancelBtn: HTMLButtonElement;
}

export default class MyMapsCreateFolder {
	_opts: IMyMapsCreateFolder;

	_dom: IDom;

	_opened: boolean;

	constructor(opts: IMyMapsCreateFolder) {
		this._opts = {
			onSave: () => {},
			onClose: () => {},
			...opts,
		};
		this._opened = false;

		this._dom = this._build();
	}

	get container() {
		return this._dom.container;
	}

	open() {
		if (!this._opened) {
			this._dom.input.focus();
			document.addEventListener("keydown", this);
			this._opened = true;
		}
	}

	destroy() {
		this._dom.container.remove();
		document.removeEventListener("keydown", this);
	}

	handleEvent(event) {
		switch (event.type) {
			case "click":
				if (event.target === this._dom.saveBtn) {
					this._save();
				} else if (event.target === this._dom.cancelBtn) {
					this.destroy();
					this._opts.onClose();
				}
				break;

			case "keydown": {
				const keyCode = event.which || event.keyCode;

				if (keyCode === 13 && event.target === this._dom.input) {
					event.stopPropagation();

					this._save();
				} else if (keyCode === 27) {
					this.destroy();
					this._opts.onClose();
				}
				break;
			}

			default:
		}
	}

	_build(): IDom {
		// vytvoreni slozky
		const createFolder = node("div", { className: "mymap-folders create-folder" });
		const createFolderInner = node("div", { className: "create-folder-inner" });

		const folderTitle = node("h3", { className: "folder-name", textContent: _("mymap.folders.folderName") });
		const folderValue = node("input", { className: "value", type: "text" });
		const error = node("p", { className: "error hide" });
		const buttons = node("div", { className: "buttons" });

		// maximalni nazev slozky
		folderValue.maxLength = 200;

		const saveBtn = node("button", { className: "save", textContent: _("save") });

		saveBtn.setAttribute("type", "button");
		saveBtn.setAttribute("data-log-ignore", "1");

		const cancelBtn = node("button", { className: "cancel", textContent: _("cancel") });

		cancelBtn.setAttribute("type", "button");

		createFolderInner.appendChild(folderTitle);
		createFolderInner.appendChild(folderValue);
		createFolderInner.appendChild(buttons);
		createFolderInner.appendChild(error);
		createFolder.appendChild(createFolderInner);

		buttons.appendChild(saveBtn);
		buttons.appendChild(cancelBtn);

		saveBtn.addEventListener("click", this);
		cancelBtn.addEventListener("click", this);
		folderValue.addEventListener("keydown", this);

		return {
			container: createFolder,
			input: folderValue,
			error,
			saveBtn,
			cancelBtn,
		};
	}

	_save() {
		const value = this._dom.input.value.trim();

		if (value.length) {
			this._error("");

			Mapy.ProviderMapyBox.folderCreate(value).then(data => {
				const folderId = data.id;
				const folderTitle = value;

				this.destroy();
				this._opts.onSave(folderId, folderTitle);
			}, error => {
				// eslint-disable-next-line no-console
				console.error(error);
				this._error(_("mymap.folders.createError"));
			});
		} else {
			this._error(_("mymap.folders.emptyFolder"));
		}
	}

	/**
	 * Zobrazeni chybove hlasky.
	 *
	 * @param  {String} [msg] Hlaska
	 */
	_error(msg: string) {
		this._dom.error.textContent = msg || "";
		this._dom.error.classList[msg ? "remove" : "add"]("hide");
	}
}
